<template>
    <div class="p-4 lg:w-full md:w-full">
        <div class="space-y-4">
            <div class="field w-full mb-3" v-for="(file, index) in existing_files" :key="index">
                <div class="flex items-center w-full">
                    <label class="text-gray-700 font-bold mr-4 w-1/4">
                        {{ file.file_dokumen_type.nama }}
                    </label>
                    <div class="bg-gray-100 p-4 rounded-lg w-3/4">
                        <div v-if="file.existing_files.length > 0" class="space-y-2">
                            <div v-for="(existing_file, nfIndex) in file.existing_files" :key="nfIndex"
                                class="flex items-center bg-gray-200 p-2 rounded">
                                <small class="text-gray-700 flex-1">{{ existing_file.nama_file_asli }}</small>
                                <Button 
                                    icon="pi pi-download" 
                                    class="p-button-secondary p-button-sm ml-2" 
                                    :label="''" 
                                    @click="downloadFile(existing_file)"
                                />
                            </div>
                        </div>
                        <template v-else>
                            <small class="text-gray-500">Tidak ada file yang diunggah</small>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import Fieldset from 'primevue/fieldset';
import Button from 'primevue/button';

export default defineComponent({
    components: {
        Fieldset,
        Button
    },
    props: {
        existing_files: Array,
    },
    methods: {
        downloadFile(file) {
            // Open the file download endpoint in a new tab
            window.open(`/file/${file.id}/download`, '_blank');
        }
    }
});
</script>
